import { Path } from '@/main/router/routerPath';

import { AkcniProdejNd } from './akcniProdejNd';
import { Dodavatel } from './dodavatel';
import { MarketoveSkupinyNd } from './marketoveSkupinyNd';
import { MernaJednotka } from './mernaJednotka';
import { PseudoNahradyNd } from './pseudoNahradyNd';
import { RabatovaSkupina } from './rabatovaSkupina';
import { Sklad } from './sklad';
import { SkladMisto } from './skladoveMisto';
import { SkupinaSlevMaterialu } from './skupinaSlevMaterialu';
import { Slevamat } from './slevamat';
import { ZboziDruh } from './zbozidruh';

export const router = new Path('Skladove').addChildren([
	AkcniProdejNd.router,
	Dodavatel.router,
	MarketoveSkupinyNd.router,
	MernaJednotka.router,
	PseudoNahradyNd.router,
	RabatovaSkupina.router,
	Sklad.router,
	SkladMisto.router,
	SkupinaSlevMaterialu.router,
	Slevamat.router,
	ZboziDruh.router,
]);
